const LCSLength = (str1, str2, m = str1.length, n = str2.length) => {
  // return if there no more characters to examine in either strings
  if (m === 0 || n === 0) {
    return 0;
  }

  // if the character at the given index of str1 and str2 matches
  if (str1[m - 1] === str2[n - 1]) {
    return LCSLength(str1, str2, m - 1, n - 1) + 1;
  }

  // else, if the character of str1 and str2 don't match
  return Math.max(
    LCSLength(str1, str2, m, n - 1),
    LCSLength(str1, str2, m - 1, n)
  );
};

export default LCSLength;
